import React, { useEffect, useState } from "react";
import PopupBG from "../../assets/svg/popup-bg.svg";
import Modal from "../Modal";
import Button from "../Button";
import { useHistory } from "react-router-dom";
import useFormValidation from "../../libs/validation/formvalidation";
// import authenticator from "../../services/authenticateService";
import ValidateAuth from "../../libs/validation/register-validation-journey";
import { usePost, useGet } from "../../libs/service/api";
import { isEmail, isEmpty, checkSpecialCharacter, checkChar, checkDigit } from '../../libs/validation/validators';
// import Input from "../../components/Input";
import Alert from "../Alert";
import commonService from "../../services/commonService";
import cookie from "../../libs/cookie/client";
import { Transition } from "@headlessui/react";
// import { Link } from "react-router-dom";
// import { isEmpty, isEmail } from '../../libs/validation/validators'
import * as Icon from 'react-feather';
const CustomDashboardModal = (props) => {
  const { toast, snackbar } = require("tailwind-toast");
  const history = useHistory();
  const userData = commonService.getUserData();
  const [registerError, setRegisterError] = useState("");
  const [emailiderror, setEmailiderror] = useState("");
  const [passworderrors, setPassworderrors] = useState("");
  const [isOnlyEmailShowing, setIsOnlyEmailShowing] = useState(true);
  const [isOnlyPasswordShowingmodel, setIsOnlyPasswordShowingmodel] = useState(false);
  const [isEmailExist, setIsEmailExist] = useState(false);
  const [isOrganizationAndNameShowing, setIsOrganizationAndNameShowing] = useState(false);
  const [emailid, setEmailid] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("")
  const [isSending, setIsSending] = useState(false)
  const INITIAL_STATE = {
    emailid: "",
    mobileno: "",
    name: "",
    password: "",
    organization: "",
  };
  const handleEmailChange = (e) => {
    setEmailiderror("");
    setEmailid(e.target.value)
  }
  const handleEmailBlur = (e) => {
    setEmailiderror("");
    setEmailid(e.target.value)
  }
  // const handlePasswordChange = (e) => {
  //   setPassworderrors("");
  //   setPassword(e.target.value)
  // }
  // const handlePasswordBlur = (e) => {
  //   setPassworderrors("");
  //   setPassword(e.target.value)
  // }

  const OnEmailSubmit = () => {
    if (isEmpty(emailid)) {
      setEmailiderror("Email ID cannot be left blank")
    } else if (!isEmail(emailid)) {
      setEmailiderror("Email ID format should be : name@example.com")
    } else {
      setIsSending(true)
      PostUserExist(emailid)
    }

  }

  // const OnPasswordSubmit = () => {
  //   if (isEmpty(password)) {
  //     setPassworderrors("Password cannot be left blank");
  //   } else {
  //     CallLogin()
  //   }
  // }

  const PostUserExist = (stremailid) => {
    useGet("/commonapi/accountexist?EmailID=" + stremailid).then((res) => {

      if (!res.ErrorState) {
        console.log(res)
        INITIAL_STATE.emailid = emailid
        if (res.Data.Table[0].type == 1) {
          cookie.setItem("email", stremailid);
          cookie.setItem("userid", res.Data.Table[0].userid);
          setIsOnlyEmailShowing(false);
          setIsEmailExist(true);
          // setIsOnlyPasswordShowing(true);
          // console.log("email");
          // console.log(res.Data);
          // } else if (res.Data.Table[0].type == 2) {
          //   cookie.setItem("email", stremailid);
          //   cookie.setItem("userid", res.Data.Table[0].userid);
          //   props.onCallPasswordClick()
          //   console.log("new email ");
          //   console.log(res.Data);
        } else if (res.Data.Table[0].type == 3) {
          cookie.setItem("email", stremailid);
          cookie.setItem("userid", res.Data.Table[0].userid);
          setIsOnlyEmailShowing(false);
          setIsOrganizationAndNameShowing(true);
        }
      }
    }
    );
  }


  const ChangePasswordClick = () => {
    if (isEmpty(password)) {
      setError("Password cannot be left blank");
    } else if (!isEmpty(password)) {
      if (password.length < 8 || !checkSpecialCharacter(password) || !checkChar(password) || !checkDigit(password)) {
        setError("Your Password needs to have at least 8 characters, 1 special character and 1 number");
      } else if (password !== confirmpassword) {
        setError("New Password and Confirm Password do not match.");
      } else {
        setIsSending(true)
        SavePassword()
      }
    }
  }
  // const CallLogin = () => {
  //   usePost('/api/auth/postlogin', { username: cookie.getItem("email"), password: password }).then(res => {

  //     cookie.setItem('authorizationKey', res.data);
  //     cookie.setItem('passwordexist', 1);
  //     cookie.setItem('username', res.name);
  //     cookie.setItem('userid', res.userid);
  //     toast().success('', 'Password Set Sucessfully').with({
  //       shape: 'square',
  //       duration: 2000,
  //       speed: 200,
  //       positionX: 'end',
  //       positionY: 'top',
  //       color: 'text-white bg-primary border-primary-dark border rounded-lg',
  //       fontColor: 'white',
  //       fontTone: 0
  //     }).show()
  //     if (props.onCustomDashboardClick() !== undefined) {
  //       props.onCustomDashboardClick()
  //     }
  //     props.closeTrigger()
  //   });

  // }

  const SavePassword = () => {
    usePost('/commonapi/savepassword',
      [{
        "key": "usersid",
        "value": cookie.getItem("userid")
      },
      {
        "key": "password",
        "value": password
      }]
    ).then(res => {
      if (!res.ErrorState) {
        CallLogin()
      }
    });
  }

  const CallLogin = () => {
    usePost('/api/auth/postlogin', { username: emailid, password: password }).then(res => {
      if (res.data == "Wrong username or password") {
        setPassworderrors(res.data)
      } else {
        setPassworderrors("")
        cookie.setItem('authorizationKey', res.data);
        cookie.setItem('passwordexist', 1);
        cookie.setItem('username', res.name);
        cookie.setItem('email', emailid);
        cookie.setItem('userid', res.userid);
        toast().success('', 'Password Set Sucessfully').with({
          shape: 'square',
          duration: 2000,
          speed: 200,
          positionX: 'end',
          positionY: 'top',
          color: 'text-white bg-primary border-primary-dark border rounded-lg',
          fontColor: 'white',
          fontTone: 0
        }).show()
        // props.onCustomDashboardClick()
        if (props.onCustomDashboardClick() !== undefined) {
          props.onCustomDashboardClick()
        }
        // props.closeTrigger()
      }
    });
  }

  const OnSuccess = () => {
    //values.emailid=emailid
    usePost("/commonapi/addlead", [
      {
        key: "emailid",
        value: emailid,
      },
      {
        key: "mobileno",
        value: "",
      },
      {
        key: "name",
        value: values.name,
      },
      {
        key: "organization",
        value: values.organization,
      },
      {
        key: "needsassesmentid",
        value: cookie.getItem("needsassesmentid"),
      },
    ]).then((res) => {
      if (!res.ErrorState) {
        if (
          res.Data.Table[0].userid > 0 &&
          res.Data.Table[0].errormessage != ""
        ) {
          //if (res.Data.Table[0].errormessage == "")

          toast()
            .success("", res.Data.Table[0].errormessage)
            .with({
              shape: "pill",
              duration: 4000,
              speed: 1000,
              positionX: "end",
              positionY: "top",
              color: "text-primary",
              fontColor: "blue",
              fontTone: 200,
            })
            .show();
        } else {
          // console.log(res.Data.Table[0]);
          cookie.setItem("username", values.name);
          cookie.setItem("email", emailid);
          cookie.setItem("passwordexist", res.Data.Table[0].passwordexist);
          cookie.setItem("userid", res.Data.Table[0].userid);
          setRegisterError("");
        }
        // props.onCustomDashboardClick();
      } else {
        setRegisterError(res.data);
      }
      // console.log("custom dashboard");
      // console.log(res.data);
    });

  };

  const closePopup = () => { };

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    // isSubmitting,
  } = useFormValidation(INITIAL_STATE, ValidateAuth, OnSuccess);

  // useEffect(() => { }, []);

  return (

    <Modal isOpen={props.isOpen} closeTrigger={() => closePopup()}>
      <div className="py-8 xl:py-8 px-4" style={{ height: 400, overflow: "hidden" }}>
        <img
          src={PopupBG}
          className="absolute right-0 top-0 h-full -mr-px z-10"
          alt=""
        />
        <div className="w-auto">
          <h4 className="text-2xl xl:text-4xl	font-bold mb-4">
            Your custom dashboard is almost ready!
          </h4>
          <p className=" w-3/4 xl:w-full">
            We need your information to create a profile and personalize your
            dashboard.
          </p>
        </div>
        <div className="w-auto h-64">

          <Transition
            show={isOnlyEmailShowing}
            enter="transform transition-translate duration-75"
            enterFrom="transform -translate-x-full"
            enterTo="transform translate-x-0"
            leave="transform transition-translate duration-0"
            leaveFrom="transform translate-x-0"
            leaveTo="transform -translate-x-full"
          >
            <div className="flex flex-col h-64 justify-between ">

              {registerError && (
                <Alert
                  type="secondary"
                  heading="Error"
                  content={registerError}
                  isVisible={true}
                />
              )}

              <div className="flex items-end whitespace-nowrap relative pt-20">
                <label className="font-bold ">My Email is</label>
                <input
                  onChange={handleEmailChange}
                  onBlur={handleEmailBlur}
                  type="email"
                  name="emailid"
                  autoComplete="off"
                  defaultValue={emailid}
                  haserror={emailiderror ? 1 : 0}
                  placeholder="Enter your work Email here"
                  className="mx-2 border-b-2 italic p-2 border-black text-sm focus:outline-none w-2/4 xl:w-1/3"
                />
                <div className="absolute top-full leading-none left-20 pl-4">
                  <span class="text-xs text-red-700">{emailiderror}</span>
                </div>
              </div>
              {errors && (
                <div>
                  <span className=""></span>
                </div>
              )}
              <div className="flex mt-14" fixedBottom={true}>
                <Button
                  type="button"
                  btnStyle="primary-outline"
                  text="Edit answers"
                  extraClasses="mr-4"
                  onClick={props.onEditAnswersClick}
                />


                {!isSending && (<Button
                  btnStyle="primary"
                  processing={isSending}
                  text="Next"
                  extraClasses="px-20"
                  onClick={() => OnEmailSubmit()}
                />)}
                {isSending && (<Button
                  btnStyle="primary"
                  processing={isSending}
                  extraClasses="px-20"
                />)}

              </div>
            </div>
          </Transition>


          <Transition
            show={isEmailExist}
            enter="transform transition-translate duration-75"
            enterFrom="transform -translate-x-full"
            enterTo="transform translate-x-0"
            leave="transform transition-translate duration-0"
            leaveFrom="transform translate-x-0"
            leaveTo="transform -translate-x-full"
          >
            <div className="flex flex-col h-64 justify-between  ">

              {registerError && (
                <Alert
                  type="secondary"
                  heading="Error"
                  content={registerError}
                  isVisible={true}
                />
              )}

              <div className="flex items-end whitespace-nowrap relative">
                <div className="flex flex-col">
                  <label className="font-bold my-8 mx-4">Email id Already Exist</label>
                  <label className=" mx-4">Please <span className="text-green-600 font-bold">Login</span> to continue your Journey</label>
                </div>
                <div className="absolute top-full leading-none left-20 pl-4">
                  <span class="text-xs text-red-700">{emailiderror}</span>
                </div>
              </div>
              {errors && (
                <div>
                  <span className=""></span>
                </div>
              )}
              <div className="flex mt-8">
                <Button
                  type="button"
                  btnStyle="primary-outline"
                  text="Back"
                  extraClasses="mr-4"
                  onClick={() => {
                    setIsOnlyEmailShowing(true);
                    setIsEmailExist(false);
                    setIsSending(false);
                  }}
                />
                <Button
                  type="button"
                  btnStyle="primary"
                  text="Login"
                  onClick={() => {
                    setIsEmailExist(false)
                    cookie.removeItem('needsassesmentid');
                    cookie.removeItem('areaofinterest');
                    cookie.removeItem('passwordexist');
                    cookie.removeItem('email');
                    cookie.removeItem('userid');
                    cookie.removeItem('authorizationKey');
                    cookie.removeItem('username');
                    cookie.removeItem('queryFormSubmmited');
                    localStorage.removeItem("needsassesmentid");
                    localStorage.removeItem("areaofinterest");
                    localStorage.removeItem("passwordexist");
                    localStorage.removeItem("email");
                    localStorage.removeItem("userid");
                    localStorage.removeItem("authorizationKey");
                    localStorage.removeItem("username");
                    localStorage.removeItem("queryFormSubmmited");
                    window.localStorage.clear();
                    history.push('/login/')
                  }}
                />
              </div>
            </div>
          </Transition>



          <Transition
            show={isOrganizationAndNameShowing}
            enter="transform transition-translate duration-150"
            enterFrom="transform translate-x-full"
            enterTo="transform translate-x-0"
            leave="transform transition-translate duration-0"
            leaveFrom="transform translate-x-0"
            leaveTo="transform translate-x-full"
          >
            <div className="flex flex-col h-64">
              <form className="xlw-9/12 xl:mt-6 h-64 flex flex-col justify-between" onSubmit={handleSubmit}>
                <div className="flex w-11/12 mb-4 xl:mb-0">
                  {registerError && (
                    <Alert
                      type="secondary"
                      heading="Error"
                      content={registerError}
                      isVisible={true}
                    />
                  )}
                  <div className="flex flex-col  mb-4 whitespace-nowrap  w-2/5 xl:w-2/4 mt-4">
                    <div className="flex flex-col xl:flex-row  xl:items-end relative  mb-6">
                      <label className="font-bold">My name is</label>
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.name}
                        name="name"
                        haserror={errors.name ? 1 : 0}
                        type="text"
                        placeholder="First &amp; last name"
                        className="xl:mx-2 border-b-2 italic p-2 border-black text-sm focus:outline-none w-full"
                      />
                      <div className="absolute top-full leading-none right-0 pr-4">
                        <span class="text-xs text-red-700">{errors.name}</span>
                      </div>
                    </div>
                    <div className="flex flex-col xl:flex-row xl:items-end relative">
                      <label className="font-bold">Organization name</label>
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.organization}
                        name="organization"
                        haserror={errors.organization ? 1 : 0}
                        type="text"
                        placeholder="Organization"
                        className="flex flex-col xl:flex-row xl:mx-2 border-b-2 italic p-2 border-black text-sm focus:outline-none w-full"
                      />
                      <div className="absolute top-full leading-none right-0 pr-4">
                        <span class="text-xs text-red-700">
                          {errors.organization}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="w-3/5 xl:w-2/4 max-w-55 border-l-2 border-gray-200 ml-2 pl-4 text-sm xl:text-base ">
                    <h4 className="font-bold mb-4 pr-8">On dashboard, you will be able to</h4>
                    <ul className="list-checked">
                      <li><small><Icon.Check className="w-4 text-white" /></small>Revisit your matched products &amp; services</li>
                      <li><small><Icon.Check className="w-4 text-white" /></small>Access product demo</li>
                      <li><small><Icon.Check className="w-4 text-white" /></small>Create a team dashboard and share with your colleagues</li>
                    </ul>
                  </div>
                </div>
                <div className="flex">

                  <Button
                    type="button"
                    btnStyle="primary-outline"
                    text="Back"
                    extraClasses="mr-4"
                    onClick={() => {
                      setIsOnlyEmailShowing(true);
                      setIsOrganizationAndNameShowing(false);
                      setIsSending(false)
                    }} />

                  <Button
                    btnStyle="primary"
                    // processing={isSending}
                    text="Next"
                    extraClasses="px-20 "
                    onClick={() => {
                      setIsOrganizationAndNameShowing(false);
                      setIsOnlyPasswordShowingmodel(true)
                      setIsSending(false)
                      // props.onCallPasswordClick()
                    }} />

                </div>
              </form>
            </div>
          </Transition>



          <Transition
            show={isOnlyPasswordShowingmodel}
            enter="transform transition-translate duration-150"
            enterFrom="transform translate-x-full"
            enterTo="transform translate-x-0"
            leave="transform transition-translate duration-0"
            leaveFrom="transform translate-x-0"
            leaveTo="transform translate-x-full"
          >
            <div className="flex flex-col h-64 justify-between">
              {/* <img src={PopupBG} className="absolute right-0 top-0 h-full -mr-px" alt="" /> */}
              {/* <div className=" flex flex-col h-64 justify-between w-full"> */}
              <p className="font-bold pt-4">Setup your <span className="text-primary">Password</span> here.</p>

              <div className="w-1/2 mt-4 flex whitespace-nowrap relative flex-col">
                <label>Password</label>
                <input
                  onChange={(e) => {
                    setError("");
                    setPassword(e.target.value)
                  }}
                  onBlur={(e) => {
                    setError("");
                    setPassword(e.target.value)
                  }}
                  type="password"
                  value={password}
                  name="password"
                  placeholder="*******" className="mr-2 border-b-2 italic p-2 border-black text-sm focus:outline-none  w-full" />
                <span class="text-xs absolute top-full text-red-700">{error}</span>
              </div>

              <div className="w-1/2 mt-4 mb-6 flex whitespace-nowrap relative flex-col ">
                <label>Confirm Password</label>
                <input
                  onChange={(e) => {
                    setError("");
                    setConfirmPassword(e.target.value)
                  }}
                  onBlur={(e) => {
                    setError("");
                    setConfirmPassword(e.target.value)
                  }}
                  type="password"
                  value={confirmpassword}
                  name="confirmpassword"
                  placeholder="*******" className="mr-2 border-b-2 italic p-2 border-black text-sm focus:outline-none  w-full" />
                <span class="text-xs absolute top-full text-red-700">{error}</span>
              </div>

              <div className="flex ">

                <Button
                  type="button"
                  btnStyle="primary-outline"
                  text="Back"
                  extraClasses="mr-4"
                  onClick={() => {
                    setIsOnlyPasswordShowingmodel(false)
                    setIsOrganizationAndNameShowing(true);
                    setIsSending(false)
                  }} />

                {!isSending && (
                  <button className="bg-primary hover:bg-primary-dark border-primary text-white font-semibold  text-base py-1.5 px-8 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none w-60"
                    onClick={() => {
                      ChangePasswordClick();
                    }}>Create account</button>
                )}

                {isSending && (
                  <button className="bg-primary border-primary py-1.5 px-8 rounded-full flex border-2  active:border-3 opacity-50 focus:outline-none w-60 justify-center pointer-events-none" >
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg></button>
                )}

              </div>

            </div>
          </Transition>

        </div>
      </div>
    </Modal>
  );
};

export default CustomDashboardModal;
